import functions from '../../../../../world/spa/libs/vuexFunctions';

export default {
    namespaced: true,
    state: {
        objs: []
    },
    getters: {
        ...functions.createDefaultGetters(['idContactsContact']),
        getByWork: state => work => {
            return state.objs.filter(contacts => contacts.workOwner === work);
        },
        getPersonalByUser: state => user => {
            return state.objs.filter(contacts => (contacts.userOwner === user.idWorldUser && !contacts.workOwner));
        },
    },
    mutations: {
        ...functions.createDefaultMutations(['idContactsContact'])
    },
    actions: {
        ...functions.createDefaultActionsWithStore(['idContactsContact'])
    },
}